/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";

const Location = () => {
  return (
    <section>
      <div className="row">
        <div className="col-md-12">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3406.915198271549!2d74.3683408154216!3d31.361319262115817!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391907ad9027b2e1%3A0x87a507057bfb56a3!2sWarraich%20Traders!5e0!3m2!1sen!2s!4v1635856323284!5m2!1sen!2s"
            width="100%"
            height="500"
            style={{ border: "0" }}
            allowfullscreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Location;
